
<svg :class="classes" :style="styles">
  <use :xlink:href="link_type"></use>
</svg>
